import { SaveBar } from '@shopify/app-bridge-react';
import { ContextualSaveBar } from '@shopify/polaris';
import React, { useEffect, useState } from 'react';
import Language from '../../i18n/Language';
const t = Language;

const SaveBarTop = (props) => {

    const isShopify = window.shopify;

    const {
        isShowSaveBar,
        saveLoading,
        handleSaveAction,   // 执行保存
        handleDiscardAction,    // 执行舍弃
    } = props;

    const [isShowCtBar, setIsShowCtBar] = useState(false);

    useEffect(() => {
        window.savebarState = Boolean(isShowSaveBar);
        if (isShopify) {
            if (isShowSaveBar) {
                isShopify.saveBar.show("public-savebar");
            } else {
                isShopify.saveBar.hide("public-savebar");
            }
        } else {
            setIsShowCtBar(isShowSaveBar);
        }
    }, [isShowSaveBar])

    const saveComponents = isShopify ? <SaveBar id='public-savebar'>
        <button variant="primary" onClick={handleSaveAction} loading={saveLoading ? "" : null}></button>
        <button onClick={handleDiscardAction} disabled={saveLoading}></button>
    </SaveBar> : isShowCtBar ? <ContextualSaveBar
        alignContentFlush
        message={t("Unsaved changes")}
        saveAction={{
            onAction: handleSaveAction,
            loading: saveLoading,
        }}
        discardAction={{
            onAction: handleDiscardAction,
            disabled: saveLoading,
        }}
    /> : null

    return saveComponents;
}

export default SaveBarTop;